import { render } from "./allstocktransfer.vue?vue&type=template&id=05960395&scoped=true"
import script from "./allstocktransfer.vue?vue&type=script&lang=js"
export * from "./allstocktransfer.vue?vue&type=script&lang=js"

import "./allstocktransfer.vue?vue&type=style&index=0&id=05960395&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05960395"]])

export default __exports__